<script>
  import Header from "./components/Header.svelte";
  import Footer from "./components/Footer.svelte";
  import PrivacyPolicy from "./routes/PrivacyPolicy.svelte";
</script>

<Header />
<main>
  <PrivacyPolicy />
</main>
<Footer />
